import request from '@/utils/request'



export const flowRefundApplyPage = (data = {}) => request({ url: `/api/estate/v1/workflow/flowRefundApplyPage`, method: 'post', data })

export const flowRefundApplyCount = (data = {}) => request({ url: `/api/estate/v1/workflow/flowRefundApplyCount`, method: 'post', data })

export const refundConfirmation = (data = {}) => request({ url: `/api/estate/v1/workflow/refundConfirmation`, method: 'post', data })

export const flowApplyRefundInfo = (data = {}) => request({ url: `/api/estate/v1/workflow/flowApplyRefundInfo`, method: 'post', data })










export const refundAuditFlowIns = (data = {}) => request({ url: `/finance/refundAuditFlowIns`, method: 'post', data })

export const refundAuditFlowUpd = (data = {}) => request({ url: `/finance/refundAuditFlowUpd`, method: 'post', data })

export const refundAuditFlowList = (data = {}) => request({ url: `/finance/refundAuditFlowPage`, method: 'post', data })

export const refundAuditFlowCount = (data = {}) => request({ url: `/finance/refundAuditFlowCount`, method: 'post', data })

export const refundAuditFlowDel = (data = {}) => request({ url: `/finance/refundAuditFlowDel`, method: 'post', data })

export const refundAuditFlowDelBatch = (data = {}) => request({ url: `/finance/refundAuditFlowDelBatch`, method: 'post', data })


export const flowOrderRefundDetail = (data = {}) => request({ url: `api/estate/v1/workflow/flowOrderRefundDetail`, method: 'post', data })

// 未完成 文档 38行